import React from 'react';
import '../../styles/styles.css';
import HlsPlayer from "../../components/hlsplayer";

export default function nashik() {
  return (
    <div className="container mt-4">
        <div className="row">
            {/* Left Large Image Box */}
            <div className="col-md-4 box1">
            <img src="/images/triambakeshwar.jpg" alt="Jyothirling" />    
            </div>

            {/* Right Information Boxes */}
            <div className="col-md-8">
                <div className="Reg-box2">
                    <p><strong>Next Important Festival Date in Triambakeshwar<br />
    Month of Kartik, Mahashivratri<br />    
    <br />

  </strong></p>
  <p>Triambakeshwar Temple Official Website for Live Darshan : <a href="https://trimbakeshwartrust.com/" target="_blank" rel="noopener noreferrer">
  Triambakeshwar Temple Website
</a>
</p>
        </div>
            </div>
        </div>

        {/* Bottom Full Width Description Box */}
        <div className="row mt-3">
            <div className="col-12 Desc-box3">
             <p>Shri Trimbakeshwar Temple is located at a distance of about 28 km from Nashik, Maharashtra near the mountain named Brahamagiri from which the river Godavari flows. It was constructed by third Peshwa Balaji Bajirao (1740-1760) on the site of an old temple. Trimbakeshwar Temple is a religious centre having one of the twelve Jyotirlingas. The present Trimbakeshwar temple was constructed by third generation Peshwa Balaji Bajirao (1740-1760) on the site of an old temple. Sant Nivruttinath, elder brother of Sant Dnyaneshwar had taken Samadhi at Trimbakeshwar.The extraordinary feature of the Jyotirlinga located here is the Linga in the temple is in the form of a three faced embodying Tridev, Lord Bramha, Lord Vishnu and Lord Shiva.</p>
            </div>
        </div>
    </div>
  )
}
